module.exports = __webpack_public_path__ + "static/media/dubaiLogo.2f451056.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/dubaiLogo.png
// module id = 47
// module chunks = 0